export default __webpack_public_path__ + "static/media/fb-icon.f5aea80d.svg";